import { Stack } from 'react-bootstrap';
import Paper from '../../../components/Paper';

const EndForm = () => {
  return (
    <Stack gap={3}>
      <Paper className="form-title">
        <div className="mb-2">
          <span className="text-title">Formulario registrado</span>
        </div>
        <div>
          <p>
            Gracias por llenar el formulario, en un momento un administrador se encargará de revisar
            el formulario.
          </p>
        </div>
      </Paper>
    </Stack>
  );
};

export default EndForm;
